import {NonDeloittePurposeOfVisitEnum, NonDeloitteTypeOfVisitEnum} from '@employee-models/data.enums';
import {IBadgeRequestPhotoInfo, INonDeloitteGuestRequest} from '@employee-models/data.models';
import {ISearchEmployeeApprovers} from '@employee-models/common.models';

export const typeOfVisitList = [
    {
        id: NonDeloitteTypeOfVisitEnum.Client,
        name: 'Client'
    },
    {
        id: NonDeloitteTypeOfVisitEnum.GovernmentOfficial,
        name: 'Government official'
    },
    {
        id: NonDeloitteTypeOfVisitEnum.Trainer,
        name: 'Trainer'
    },
    {
        id: NonDeloitteTypeOfVisitEnum.Others,
        name: 'Others'
    }
];

export const purposeOfVisitList = [
    {
        id: NonDeloittePurposeOfVisitEnum.BusinessVisit,
        name: 'Business visit'
    },
    {
        id: NonDeloittePurposeOfVisitEnum.AuditAssessment,
        name: 'Audit assessment'
    }
];

export interface INonDeloitteGuestRequestWithPhoto extends INonDeloitteGuestRequest {
    entityOrFssName?: string;
    typeOfVisitName?: string;
    purposeOfVisitName?: string;
    photo?: IBadgeRequestPhotoInfo;
    approversFull?: ISearchEmployeeApprovers[];
    approversFullIRC: ISearchEmployeeApprovers[];
}
